import { ELoginAs } from '@aqx-core/common/api/auth';
import { ICompany } from '@aqx-core/common/api/config';

export const getDemoRegistrationUrlObject = (
  companyProfile: ICompany | null | undefined
): Partial<Record<ELoginAs, string>> => {
  const { mt5DemoRegistrationUrl: mt5DemoRegisterUrlWeb, mt4DemoRegistrationUrl: mt4DemoRegisterUrlWeb } =
    companyProfile ?? {};

  return {
    [ELoginAs.MT5_DEMO]: mt5DemoRegisterUrlWeb,
    [ELoginAs.MT4_DEMO]: mt4DemoRegisterUrlWeb,
    [ELoginAs.OMS_DEMO]: mt4DemoRegisterUrlWeb ?? mt5DemoRegisterUrlWeb
  };
};

const getLiveRegistrationUrlObject = (
  companyProfile: ICompany | null | undefined
): Partial<Record<ELoginAs, string>> => {
  const { mt5LiveRegistrationUrl: mt5LiveRegisterUrlWeb, mt4LiveRegistrationUrl: mt4LiveRegisterUrlWeb } =
    companyProfile ?? {};

  return {
    [ELoginAs.MT5_LIVE]: mt5LiveRegisterUrlWeb,
    [ELoginAs.MT4_LIVE]: mt4LiveRegisterUrlWeb,
    [ELoginAs.OMS_LIVE]: mt4LiveRegisterUrlWeb ?? mt5LiveRegisterUrlWeb
  };
};

export const getRegistrationUrl = (companyProfile: ICompany | null | undefined, selectedTab: ELoginAs | undefined) => {
  if (!selectedTab) {
    return '';
  }

  if (selectedTab === ELoginAs.LIVE) {
    return companyProfile?.companyRegistrationUrl;
  }

  const registrationUrl: Partial<Record<ELoginAs, string>> = {
    ...getDemoRegistrationUrlObject(companyProfile),
    ...getLiveRegistrationUrlObject(companyProfile)
  };

  return registrationUrl?.[selectedTab];
};
